import { defineMessage } from 'services/localization';

export const messages = {
    whatIsPasskey: defineMessage('what_is_a_passkey'),
    howToPasskey: defineMessage('how_to_set_up_delete_a_passkey'),
};
